/**
 =========================================================
 * Material Dashboard 2 PRO React - v2.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

import { useEffect, useMemo, useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "views/LayoutContainers/DashboardLayout";
import DashboardNavbar from "views/Navbars/DashboardNavbar";
import Footer from "views/Footer";

// Project page components
// Images
import { useGetPhotosByEventQuery, usePhotoRemoveMutation } from "../../../../store/api/events";
import { useParams } from "react-router-dom";
import Card from "@mui/material/Card";
//
import Gallery from "react-grid-gallery";
import PhotoDropzone from "./components/PhotoDropzone";
import MDButton from "../../../../components/MDButton";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { notificationActions } from "../../../../store/notification/notification-slice";
import { useDispatch } from "react-redux";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";

function AllPhotos() {
  const { id } = useParams();
  const { data, isLoading, error } = useGetPhotosByEventQuery(id);
  const [open, setOpen] = useState(false);
  const [ photoRemove ] = usePhotoRemoveMutation();
  const dispatch = useDispatch();
  const [currentImage, setCurrentImage] = useState(0);
  const [selectedCount, setSelectedCount] = useState(0);
  const [isSelectionChanged, setIsSelectionChanged] = useState();

  const onCurrentImageChange = (index) => {
    setCurrentImage(index);
  }

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };



  useEffect(() => {
    if (data) {
      const images = data.results.filter(v => v.watermark !== null).map(v => ({
        id: v.photo,
        thumbnail: v.thumb,
        src: v.watermark,
        thumbnailWidth: parseInt(v.thumb_ratio * 240),
        thumbnailHeight: 240
      }));
      setImages(images);
    }
  }, [data]);

  const [images, setImages] = useState([]);

  const onSelectImage = (index, image) => {
    const newImages = images;
    let img = newImages[index];
    if (img.hasOwnProperty("isSelected"))
      img.isSelected = !img.isSelected;
    else
      img.isSelected = true;
    setImages(newImages);
    setIsSelectionChanged(!isSelectionChanged);
  };

  useEffect(()=>{
    setSelectedCount(images.filter(i => i.isSelected === true).length);
  },[images, isSelectionChanged]);

  const removeHandler = async () => {
    const willRemoveImages = images.filter(i => i.isSelected === true).map(i => i.id);
    if(willRemoveImages.length>0){
    try {
      await photoRemove(willRemoveImages.join(","));
      dispatch(notificationActions.showMessage({ message: "Successfully removed", variant: "success" }));
      handleClose();
    } catch (e) {
      for (const [key, value] of Object.entries(e.data)) {
        dispatch(notificationActions.showMessage({ message: key + ": " + value, variant: "error" }));
      }
    }
    }else{
      handleClose(true);
      setIsAnySelected(false);
      dispatch(notificationActions.showMessage({ message: "Please an image select", variant: "warning" }));
    }
  };
  const getSelectedCount = () => images.filter(i => i.isSelected === true).length;


  const token = localStorage.getItem("token");
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pb={3}>
        <MDBox mt={2}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12} lg={12}>
              <Card>
                {/*<DropzoneComponent/>*/}
                {
                  useMemo(
                    () => (
                      <PhotoDropzone event_id={id} options={{
                        maxFiles: 100,
                        autoDiscover: false,
                        autoQueue: true,
                        autoProcessQueue: true,
                        headers: {
                          "Cache-Control": null,
                          "X-Requested-With": null,
                          "Authorization": "JWT " + token
                        },
                        parallelUploads: 5
                        ,
                        uploadMultiple: false,
                        acceptedFiles: ".jpeg,.jpg,.png"
                      }} />
                    ), [])
                }
              </Card>
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
              <Card>
                <MDButton variant="gradient" color="error" disabled={selectedCount===0} onClick={handleClickOpen}
                          fullWidth>
                  Remove Selected {selectedCount} images
                </MDButton>
                <Dialog
                  open={open}
                  onClose={handleClose}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                >
                  <DialogTitle id="alert-dialog-title">
                    {"Remove Selected Photographs"}
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                      Are you sure? {selectedCount} images will be removed.
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <MDButton onClick={handleClose} color="success" autoFocus>No</MDButton>
                    <MDButton onClick={removeHandler} color="error">
                      Yes
                    </MDButton>
                  </DialogActions>
                </Dialog>
                {useMemo(() => <Gallery images={images} onSelectImage={onSelectImage}
                                        backdropClosesModal={true}
                                        showLightboxThumbnails={true}
                                        currentImageWillChange={onCurrentImageChange}
                                        customControls={[
                                          <IconButton color="info" onClick={()=>onSelectImage(currentImage)}>
                                            <Icon >check</Icon>
                                          </IconButton>
                                        ]}
                />, [images, currentImage, selectedCount])}
              </Card>
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default AllPhotos;
